import {
  type ComponentPropsWithRef,
  type ElementType,
  type ReactNode,
} from "react";
import styles from "./Status.module.css";
// @ts-expect-error pure js
import { classnames } from "../../utils";
import Text, { type Color, type Variant, type Weight } from "./Text.tsx";

type StatusProps<T extends ElementType = "div"> = {
  color: Color;
  text: ReactNode;
  className?: string;
  variant?: Variant;
  weight?: Weight;
  /** Icône affichée avant le texte (type de composant, pas un élément JSX). */
  icon?: ElementType;
  as?: T;
} & Omit<ComponentPropsWithRef<T>, "color" | "className" | "children">;

export default function Status<T extends ElementType = "div">({
  color,
  text,
  className,
  variant = "deci",
  weight,
  icon: Icon,
  as = "div" as T,
  ...rest
}: StatusProps<T>) {
  return (
    <Text
      as={as}
      variant={variant}
      weight={weight}
      background
      color={color}
      className={classnames(styles.status, className)}
      // TS ne sait pas vérifier le forwarding de props entre deux composants
      // polymorphes (Omit sur générique non résolu) — cast nécessaire
      {...(rest as Omit<ComponentPropsWithRef<T>, "children" | "className">)}
    >
      {Icon && <Icon size={14} stroke={2.5} />}
      {text}
    </Text>
  );
}
